module.exports = __webpack_public_path__ + "img/logo-removebg-preview.png";